export const DEFAULT_TC_PERMISSIONS_STATE_KEY = 'tc-permissions';

export interface TcPermissionsState {
  permissions: [string, string][];
}

export const initialTcPermissionsState: TcPermissionsState = {
  permissions: null,
};
